export const visit = (vm, at) => {
vm(require("foundations-components/lang/vi.lyaml"));
at({ "vi": { "placeholder": "ch\u1ED7 d\xE0nh s\u1EB5n" } });
};